// WarningCard.jsx
import React from 'react';
import { Card, TextBox, StyledAlertIcon, IconContainer, ContentWrapper } from './styles';

export const AdministrativoCard = () => {
  return (
    <Card>
      <ContentWrapper>
        <IconContainer>
          <StyledAlertIcon />
        </IconContainer>
        <TextBox>
          Para iniciar a etapa <strong>Administrativo</strong>, envie todos os documentos obrigatórios das etapas <strong>Comercial</strong>, <strong>Jurídico</strong> e do tópico <strong>"PRÉ-ANÁLISE DE VIABILIDADE"</strong>, localizado em <strong>Ambiental → Gerenciar Projeto</strong>.
        </TextBox>
      </ContentWrapper>
    </Card>
  );
};